export const EMPTY_CATEGORY_FILTER = 'no-category'
